<div class="page-title">
  <h1>Exportar dados</h1>
</div>

<!-- ===== EMPRESA + ENDEREÇO ===== -->
<div class="secoes-container">

  <div class="secao">
    <p class="titulo-secao">EMPRESA</p>

    <mat-form-field appearance="outline" class="campo-pesquisa">
      <mat-label>Pesquisar empresa</mat-label>
      <input
        matInput
        type="text"
        (input)="filtrarEmpresas($event)"
        placeholder="Digite o nome da empresa"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <div class="lista-itens">
      <div *ngFor="let empresa of listaDeEmpresas" class="item-lista">
        <mat-checkbox
          [checked]="empresa.selecionado"
          (change)="toggleEmpresa(empresa, $event.checked)"
        >
          {{ empresa.nomeFantasia }}
        </mat-checkbox>
      </div>

      <p class="sem-resultados" *ngIf="listaDeEmpresas.length === 0">
        Nenhuma empresa encontrada.
      </p>
    </div>
  </div>

  <div class="secao" *ngIf="empresaSelecionada">
    <p class="titulo-secao">ENDEREÇO</p>

    <mat-form-field appearance="outline" class="campo-pesquisa">
      <mat-label>Pesquisar endereço</mat-label>
      <input
        matInput
        type="text"
        (input)="filtrarEnderecos($event)"
        placeholder="Digite o endereço"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <div class="lista-itens">
      <div *ngFor="let endereco of listaDeEnderecos" class="item-lista">
        <mat-checkbox
          [checked]="endereco.selecionado"
          (change)="toggleEndereco(endereco, $event.checked)"
        >
          {{ endereco.labelEndereco }}
        </mat-checkbox>
      </div>

      <p class="sem-resultados" *ngIf="listaDeEnderecos.length === 0">
        Nenhum endereço encontrado.
      </p>
    </div>
  </div>

</div>

<!-- ===== PESSOAS ===== -->
<ng-container *ngIf="enderecoSelecionado">
  <p class="titulo-secao">PESSOAS</p>

  <mat-form-field appearance="outline" class="campo-pesquisa">
    <mat-label>Pesquisar pessoa</mat-label>
    <input
      matInput
      type="text"
      (input)="filtrarPessoas($event)"
      placeholder="Nome ou documento"
    />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <ng-container *ngIf="!isLoadingPessoas; else loadingTpl">
    <table mat-table [dataSource]="pessoas" matSort class="tabela-pessoas">

      <ng-container matColumnDef="selecionar">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            [checked]="todosSelecionados"
            [indeterminate]="algunsPessoasSelecionados"
            (change)="toggleTodos($event.checked)"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let pessoa">
          <mat-checkbox
            [checked]="pessoaSelecionada(pessoa)"
            (change)="alternarPessoaSelecionada(pessoa, $event.checked)"
          ></mat-checkbox>
        </td>
      </ng-container>

      <ng-container *ngFor="let coluna of colunasTabela" [matColumnDef]="coluna.id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ coluna.header }}</th>
        <td mat-cell *matCellDef="let row">{{ row[coluna.propriedade] }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [class.selecionado]="pessoaSelecionada(row)"
      ></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          Nenhuma pessoa encontrada.
        </td>
      </tr>
    </table>

    <div class="rodape-tabela">
      <span class="contagem">{{ inicio }}–{{ fim }} de {{ total }}</span>
      <mat-paginator
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPageChange($event)"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </ng-container>

  <ng-template #loadingTpl>
    <div class="loading">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  </ng-template>
</ng-container>

<!-- ===== PERÍODO ===== -->
<ng-container *ngIf="pessoasSelecionadasLocal.length > 0">
  <p class="titulo-secao">PERÍODO</p>

  <div class="data-hora-container">
    <mat-form-field appearance="outline" class="campo-form">
      <mat-label>Data inicial*</mat-label>
      <span matPrefix class="icone-btn">
        <img
          alt="data"
          src="../../../../assets/svg/icons/calendar.svg"
          style="width: 20px; margin-right: 8px"
        />
      </span>
      <input
        matInput
        readonly
        [matDatepicker]="dataInicioPicker"
        placeholder="Selecionar data inicial"
        [(ngModel)]="dataInicio"
        [min]="minData"
        [max]="dataInicioMax"
        (click)="dataInicioPicker.open()"
        (focus)="dataInicioPicker.open()"
      />
      <mat-datepicker #dataInicioPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="campo-form">
      <mat-label>Data final*</mat-label>
      <span matPrefix class="icone-btn">
        <img
          alt="data"
          src="../../../../assets/svg/icons/calendar.svg"
          style="width: 20px; margin-right: 8px"
        />
      </span>
      <input
        matInput
        readonly
        [matDatepicker]="dataFimPicker"
        placeholder="Selecionar data final"
        [(ngModel)]="dataFim"
        [min]="dataFimMin"
        [max]="maxData"
        (click)="dataFimPicker.open()"
        (focus)="dataFimPicker.open()"
      />
      <mat-datepicker #dataFimPicker></mat-datepicker>
    </mat-form-field>
  </div>
</ng-container>

<!-- ===== BOTÃO EXPORTAR ===== -->
<div class="container-inferior" *ngIf="pessoasSelecionadasLocal.length > 0">
  <button
    class="btn-cheio"
    [disabled]="!formularioValido"
    (click)="gerarArquivo()"
  >
    Gerar arquivo para exportação
  </button>
</div>